import React, { useEffect } from 'react';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';
import "./Services.css";   // merged css
import Cosection from '../components/Cosections';
import NavBar from '../components/Nav';
import Footer from '../components/footer';

import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const items = document.querySelectorAll('.timeline li');

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function callbackFunc() {
      for (let i = 0; i < items.length; i++) {
        if (isElementInViewport(items[i])) {
          items[i].classList.add('in-view');
        }
      }
    }

    window.addEventListener('load', callbackFunc);
    window.addEventListener('resize', callbackFunc);
    window.addEventListener('scroll', callbackFunc);

    return () => {
      window.removeEventListener('load', callbackFunc);
      window.removeEventListener('resize', callbackFunc);
      window.removeEventListener('scroll', callbackFunc);
    };
  }, []);

  // Individual Services
  const individualServices = [
    { title: 'Federal & State Tax Filing', description: 'Your guide through the tax jungle. Accurate filing, expert planning, all tax needs covered. Free yourself, choose Litax!', link: '/federal' },
    { title: 'Amendment', description: 'Amend your tax return with expert help for accuracy and efficiency. Correct errors, claim deductions, and maximize your refund.', link: '/amendment' },
    { title: 'ITIN Preparation', description: 'Streamlined ITIN application process by certified agents. Expert assistance for Form W-7, identity document certification, and IRS submission.', link: '/itinpreparation' },
    { title: 'FBAR & FATCA', description: 'FBAR (FINCEN114) & FATCA filing made easy. Report foreign financial accounts & assets accurately. Avoid penalties.', link: '/fbar' },
    { title: 'W4 Assistance', description: 'Optimize your W-4 with expert assistance from Litax. Claim allowances, ensure accuracy, and align withholding with your financial goals.', link: '/w4assistance' },
    { title: 'Tax Extension Filing', description: 'Request a tax filing extension with Litax. Get expert assistance, avoid penalties, and ensure timely compliance.', link: '/taxextension' },
    { title: 'Estimate Tax Payments', description: 'Let Litax handle your estimated taxes to avoid IRS penalties. Our experts ensure accurate filings, saving you time and providing peace of mind.', link: '/estimatetax' },
    { title: 'Tax Planning', description: 'Litax offers expert tax planning by CPAs and EAs to minimize liabilities. Personalized strategies for long-term financial success.', link: '/taxplanning' },
    { title: 'Tax Representation before IRS', description: 'Litax assures expert support through IRS audits. Trust our professionals for comprehensive representation and resolution.', link: '/representation' },
    { title: 'Filing Options', description: 'Your trusted partner for seamless tax filing. Opt for speedy e-filing or traditional paper filing. Contact us for expert assistance today.', link: '/filingoptions' },
  ];

  // Business Services
  const businessServices = [
    { title: 'Business Incorporation', description: 'Your gateway to seamless business formation in the USA. Expert guidance, affordable fees, and a streamlined process. Schedule your FREE consultation today!', link: '/business' },
    { title: 'Business Tax Returns', description: 'Expert tax filing for businesses and individuals. Comprehensive services, personalized approach, and commitment to compliance.', link: '/businessreturns' },
    { title: 'Accounting & Bookkeeping', description: 'Your reliable partner for accounting and bookkeeping using QuickBooks and Xero. Keep your finances organized and tax-ready with our expert support.', link: '/bookkeeping' },
    { title: 'Payroll Processing Services', description: 'Simplify payroll with Gusto and ADP. Ensure compliance with U.S. tax laws and save time while focusing on your business growth.', link: '/payroll' },
    { title: 'International Business Tax Forms', description: 'Navigate U.S. tax requirements for international businesses. Get expert help with forms like 5471, 5472, and 8865 to ensure compliance and accurate reporting.', link: '/international' },
    { title: 'BOIR', description: 'Comply with U.S. regulations for BOIR filings. Accurately report beneficial ownership information to meet federal requirements and avoid penalties.', link: '/boir' },
  ];

  return (
    <div>
      
      <NavBar />

      {/* Individual Services */}
      <div className="bgservices">
        <h2 className="services-heading">Individual Services</h2>
        <section className="timeline">
          <ul>
            {individualServices.map((service, index) => (
              <li key={index}>
                <div>
                  <time>{service.title}</time>
                  {service.description}
                  <br />
                  <Link to={service.link} className="readmore-link">
                    Read more <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>

      {/* Business Services */}
      <div className="bgservices">
        <h2 className="services-heading">Business Services</h2>
        <section className="timeline">
          <ul>
            {businessServices.map((service, index) => (
              <li key={index}>
                <div>
                  <time>{service.title}</time>
                  {service.description}
                  <br />
                  <Link to={service.link} className="readmore-link">
                    Read more <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Services;
